import isBackOffice from 'utils/appUtils';

import { PROFILE_STEP_TYPES } from 'app/constants';

import UserProfile from './components/UserProfile';
import CompanyProfile from './components/CompanyProfile';
import LocalMarket from './components/LocalMarket';
import Fees from './components/Fees';
import Coverage from './components/Coverage';
import Professional from './components/Professional';
import EandO from './components/EandO';
import Credentials from './components/Credentials';

import Completion from './components/Completion';

const steps = [
  {
    type: PROFILE_STEP_TYPES.USER_PROFILE,
    component: UserProfile,
    icon: 'user',
    wizardOnly: false,
  },
  {
    type: PROFILE_STEP_TYPES.COMPANY_PROFILE,
    component: CompanyProfile,
    icon: 'team',
    wizardOnly: false,
  },
  {
    type: PROFILE_STEP_TYPES.LOCAL_MARKET,
    component: LocalMarket,
    icon: 'environment',
    wizardOnly: true,
  },
  {
    type: PROFILE_STEP_TYPES.FEES,
    component: Fees,
    icon: 'dollar',
    wizardOnly: false,
  },
  {
    type: PROFILE_STEP_TYPES.COVERAGE,
    component: Coverage,
    icon: 'compass',
    wizardOnly: false,
  },
  {
    type: PROFILE_STEP_TYPES.PROFESSIONAL,
    component: Professional,
    icon: 'solution',
    wizardOnly: false,
  },
  {
    type: PROFILE_STEP_TYPES.CREDENTIALS,
    component: Credentials,
    icon: 'idcard',
    wizardOnly: false,
  },
  {
    type: PROFILE_STEP_TYPES.E_AND_O,
    component: EandO,
    icon: 'paper-clip',
    wizardOnly: false,
  },
  {
    type: PROFILE_STEP_TYPES.COMPLETION,
    component: Completion,
    icon: 'check-circle',
    wizardOnly: true,
  },
];

const filteredSteps = isBackOffice ? steps.filter(s => s.wizardOnly === false) : steps;

export default filteredSteps;

export const stepRouteToConstant = route => `${route}`.replace(/-/g, '_').toUpperCase();

export const constantToStepRoute = route => `${route}`.replace(/_/g, '-').toLowerCase();


